var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new__custom__field__label" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Delete",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.removeField },
          model: {
            value: _vm.showDeleteFieldModal,
            callback: function($$v) {
              _vm.showDeleteFieldModal = $$v
            },
            expression: "showDeleteFieldModal"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this field?")])]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "exclude-outside-click",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.controlFieldEdit.apply(null, arguments)
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.customField.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editingLabel,
              expression: "editingLabel"
            }
          ],
          staticClass: "edit-label-field"
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.customField.label,
                expression: "customField.label"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside,
                expression: "outside"
              }
            ],
            ref: "editLabelField",
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.customField.label },
            on: {
              blur: _vm.updateLabel,
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.updateLabel.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.customField, "label", $event.target.value)
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "remove-field",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.showDeleteFieldModal = true
            }
          }
        },
        [_c("i", { staticClass: "fas fa-trash" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }